<template>
  <v-text-field 
    :value="value"
    :rules="rules"
    :disabled="disabled"
    :placeholder="placeholder"
    :label="label"
    :solo="solo"  
    :light="solo"
    :error-messages="errorMessages"
    :suffix="suffix"
    :readonly="readonly"
    :hide-details="hideDetails"
    :maxlength="maxlength"
    dense
    flat  
    outlined  
    required
    @input="$emit('input', $event)"
    @change="$emit('change')" 
    @paste="pastePrevent"
    @keydown="keydownMethodNumber"
  >
    <template slot="append-outer"> 
      <slot name="append-outer" />
    </template>
  </v-text-field> 
</template>

<script> 
import { textfieldMix } from '@/mixins/TextField'
const regNumber = eval('/^\\d+$/')

export default {
  mixins:[textfieldMix],
  props: {
    allowDecimal: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value (val){
      this.$emit('input',val)
    }
  },
  methods : {
    pastePrevent (e) {
      if(this.preventPaste) {
        e.preventDefault()
        return 
      }
      this.$emit('paste',e)
    },
    keydownMethodNumber (e) {
      const val = String(this.value ?? '')
      const allowDot = this.allowDecimal && e.key === '.' && !val.includes('.')

      if( e.key
          && e.keyCode !== 8
          && e.keyCode !==46
          && e.keyCode !==13
          && !regNumber.test(e.key)
          && !allowDot
      ){
          e.preventDefault()
          return
      }

      const dotIndex = val.indexOf('.')
      const caret = e.target ? e.target.selectionStart : val.length
      const hasSelection = e.target && e.target.selectionStart !== e.target.selectionEnd
      if( this.allowDecimal
          && regNumber.test(e.key)
          && dotIndex !== -1
          && caret > dotIndex
          && (val.length - dotIndex - 1) >= 2
          && !hasSelection
      ){
          e.preventDefault()
          return
      }

      this.$emit('keydown',e)
    },
  }
}
</script>